var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"app-header"},[_c('app-title',{attrs:{"homeUrl":"/"},on:{"goHome":_vm.goHome}}),_c('app-logout')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }